import React from "react";
import { Grid, Row, Col, Space } from "antd";
import AppLayout from "../components/AppLayout";
import styles from "./TNC.module.css";
import { useHistory } from "react-router-dom";

const { useBreakpoint } = Grid;

const FAQ = () => {
  const breakpoint = useBreakpoint();
  const history = useHistory();

  return (
    <AppLayout backgroundColor="rgba(0, 0, 0, 0.20)">
      <div style={{ height: "auto" }}>
        <div
          className={styles.tncContainer}
          style={{
            paddingBottom: breakpoint?.md ? 148 : 40,
          }}
        >
          <Row
            align="middle"
            style={{
              paddingLeft: 18,
              paddingRight: 18,
              marginTop: breakpoint?.md ? 48 : 40,
            }}
            className={`${styles.ft_18} ${styles.textBtn}`}
            onClick={() => {
              history.goBack();
            }}
          >
            <img
              src="/images/back.png"
              alt=""
              style={{ width: 18, height: 18, marginRight: 4 }}
            />
            Back
          </Row>
          <Row
            className={styles.ft_44_900}
            style={{
              paddingLeft: 18,
              paddingRight: 18,
              paddingTop: breakpoint?.md ? 148 : 32,
            }}
          >
            FAQ
          </Row>

          <Space
            direction="vertical"
            style={{ marginTop: 20, paddingLeft: 18, paddingRight: 18 }}
            size={24}
          >
            <div>
              <div className={styles.ft_24_700}>
                What is this store site for?
              </div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                This store site is designed to offer users secure storage for
                their Live4Well Genesis and provide bonus rewards from the
                Live4Well ecosystem. By joining early and storing your Genesis
                NFT, you can maximize your rewards and unlock the highest
                potential benefits.
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>What is a smart contract?</div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                A smart contract is a digital contract stored on a blockchain
                that is automatically executed when predetermined terms and
                conditions are met. It eliminates the need for intermediaries
                and ensures immediate certainty of the outcome for all
                participants. Smart contracts can automate the execution of
                agreements and workflows, triggering the next action only when
                predetermined conditions are met.
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>Important Notice:</div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                <div>
                  Please download the Live4Well app and set up a Sportive
                  Wallet. Transfer all Genesis NFTs to your Sportive Wallet
                  within the app.
                </div>
                <div style={{ marginTop: 16 }}>
                  We highly recommend storing your Live4Well Genesis NFT on the
                  designated store site to ensure your account receives
                  supplementary rewards from the Live4Well ecosystem.
                </div>
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>
                How does the storage function work?
              </div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                <div>
                  The storage function operates through secure smart contracts
                  that enforce specific transfer rules and protect the integrity
                  of the NFTs on the blockchain. When a user stores their NFT,
                  it is temporarily stored in a smart contract from their
                  original wallet. The NFT can only be transferred back to the
                  original staking wallet under two main conditions:
                </div>
                <div style={{ marginTop: 16 }}>
                  End of Storing Period: Once the storing period is over, the
                  NFT can only be transferred to the original wallet address
                  until the original user requests the transfer via the store
                  site.
                </div>
                <div style={{ marginTop: 16 }}>
                  Restricted Transfers: The NFT can only be transferred to the
                  original wallet address to maintain security and ownership
                  integrity as per the smart contract conditions.
                </div>
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>
                What should I do after storing my NFT?
              </div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                <div>
                  Participate in upcoming farming events: Engage in our upcoming
                  farming events to earn more farming points, which are related
                  to our $VI airdrop.
                </div>
                <div style={{ marginTop: 16 }}>
                  Sit tight and enjoy the benefits: By storing your Genesis NFT,
                  you gain access to various benefits and rewards (details
                  below).
                </div>
                <div style={{ marginTop: 16 }}>
                  {`Unstore your NFT once the storage period ends: Once the storage period for your NFT comes to an end, it's important to unstore it. Only you have the authority to instruct the smart contract to transfer the NFT back to your original wallet address. Take this step to ensure a seamless transition and maintain control over your assets.`}
                </div>
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>
                What are the benefits of storing our NFT?
              </div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                <div>
                  1. Redemption of multinational fitness room passes, classes,
                  and special rewards.
                </div>
                <div>
                  2. Receiving special tickets to claim mystery boxes related to
                  $VI (upcoming Token Generation Event).
                </div>
                <div>
                  3. Unlocking more features in the Live4Well app, including
                  extra energy levels and challenges for farming more sweat
                  points than others.
                </div>
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>
                Can I store multiple Genesis NFTs?
              </div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                Yes, you can store multiple Genesis NFTs by using different
                wallets. Each wallet can store one Genesis NFT. Storing more
                Genesis NFTs allows you to multiply your benefits, including
                more mystery boxes for $VI!
              </div>
            </div>

            <div>
              <div className={styles.ft_24_700}>{`What's next?`}</div>
              <div className={styles.ft_18} style={{ marginTop: 12 }}>
                Live4Well Token Generation Event (TGE) will be happening soon as
                well as other exciting events, stay tuned and follow our X or
                join Discord for the latest update!
              </div>
            </div>
          </Space>
        </div>
      </div>
    </AppLayout>
  );
};

export default FAQ;
